import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Dashboard = ({ authToken, setAuthToken }) => {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
      return;
    }

    axios
      .get("https://meine-fastapi-api-b6fyhsg2dcejcab9.westeurope-01.azurewebsites.net/user/me", {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => setUserData(res.data))
      .catch(() => {
        setAuthToken(null);
        localStorage.removeItem("authToken");
        navigate("/login"); // Redirect to login if token is invalid
      });
  }, [authToken, navigate, setAuthToken]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    setAuthToken(null);
    navigate("/login");
  };

  return (
    <div>
      <h2>Willkommen im Dashboard</h2>
      {userData ? (
        <>
          <p>Benutzer: {userData.username}</p>
          <button onClick={handleLogout}>Logout</button>
        </>
      ) : (
        <p>Laden...</p>
      )}
    </div>
  );
};

export default Dashboard;
